import classNames from "classnames/bind"
import { StyledButton } from "./styled"
import { ButtonProps } from "../types"
import styles from "../../styles/main.scss"

const cx = classNames.bind(styles)
export const Button = ({ color, children, onClick }: ButtonProps) => (
  <StyledButton className={cx("base-button")} color={color} onClick={onClick}>
    {children}
  </StyledButton>
);
